import { DevelopmentPanelArea } from '../../../../components/tables/DevelopmentPanel'

type DevelopmentTabPanelProps = {
  uuid: string
}
export const DevelopmentTabPanel = ({ uuid }: DevelopmentTabPanelProps) => {
  return <DevelopmentPanelArea uuid={uuid} />
}
